import type { FC } from "react";
import AnserwerEmpty from "../assets/answerer_empty.svg";
import { useAgreedAnswerers } from "../features/answerer/hooks/useAgreedAnswerers";
import { Button, SpinAnimation } from "@twioku/common_components";
import { Path } from "../routes/PagePath";
import { useNavigate } from "react-router-dom";
import { QuestionAnswererItem } from "../features/question/components/QuestionAnswererItem";

export const QuestionAnswerersPage: FC = () => {
    const { answerers, isLoading } = useAgreedAnswerers();

    const navigate = useNavigate();

    if (isLoading) {
        return (
            <div className="absolute inset-0 flex items-center justify-center">
                <SpinAnimation />
            </div>
        );
    }

    if (!answerers || answerers.length === 0) {
        return (
            <>
                <h1 className="mx-auto mt-32 w-3/4 text-center text-2xl font-bold">
                    まだ誰ともやりとりをしていません…
                </h1>

                <div className="mt-40 flex flex-col items-center">
                    <img src={AnserwerEmpty} alt="AnserwerEmptyImg" />
                </div>

                <div className="fixed bottom-0 left-1/2 w-11/12 -translate-x-1/2 bg-white">
                    <Button
                        onClick={() => navigate(Path.receivernickname)}
                        className="mb-6 mt-6 h-12 w-full"
                    >
                        やり取り相手を追加する
                    </Button>
                </div>
            </>
        );
    }

    return (
        <div>
            <div className="m-4">
                <div className="mb-6 text-sm text-gray-600">
                    <p>
                        ツイオクから届く定番の質問に加えて、親御さまに向けたオリジナル質問を追加できます。
                        <br />
                        ツイオクを利用していて聞いてみたいことが思いついたら、こちらから質問を追加してみましょう！
                    </p>
                </div>
            </div>

            {answerers.map((answerer) => {
                return (
                    <div key={answerer.answererId} className="border-b-2">
                        <QuestionAnswererItem answerer={answerer} />
                    </div>
                );
            })}
        </div>
    );
};
